<div [formGroup]="formGroup" class="time-picker-container" [class.disabled]="disabled()">
    <span class="text-xs font-medium">{{label()}}</span>
    <div class="flex gap-2 time-picker">
        <div class="flex flex-col pt-[6px]">
            <input
                matInput
                formControlName="hours"
                class="w-[50px] h-9 rounded-lg text-center"
                type="number"
                (keydown)="preventPlusMinus($event)"
                (input)="onTimeChange($event, 'hours')"
                (blur)="onTimeBlur($event, 'hours')"
                minlength="2"
                maxlength="2"
                [disabled]="disabled()"
                [readonly]="disabled()"
            />
            <span class="text-xs font-normal" i18n>Hour</span>
        </div>
        <span class="text-[28px]">:</span>
        <div class="flex flex-col pt-[6px]">
            <input
                matInput
                type="number"
                (keydown)="preventPlusMinus($event)"
                (input)="onTimeChange($event, 'minutes')"
                (blur)="onTimeBlur($event, 'minutes')"
                class="w-[50px] h-9 rounded-lg text-center"
                minlength="2"
                maxlength="2"
                formControlName="minutes"
                [disabled]="disabled()"
                [readonly]="disabled()"
            />
            <span class="text-xs font-normal" i18n>Minute</span>
        </div> 
    </div>
</div>